import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LanguageContext";

export default function RegisterPage() {
  const { register } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await register(form.email, form.password, form.name);
      nav("/account");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Registration failed");
    } finally { setLoading(false); }
  };

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="register-page">
      <h1 className="font-display font-black text-5xl tracking-tighter mb-8">{t.auth.register}</h1>
      <form onSubmit={submit} className="space-y-4">
        <input required className="vt-input" placeholder={t.auth.name} value={form.name} onChange={upd("name")} data-testid="register-name" />
        <input required type="email" className="vt-input" placeholder={t.auth.email} value={form.email} onChange={upd("email")} data-testid="register-email" />
        <input required type="password" minLength={6} className="vt-input" placeholder={`${t.auth.password} (min 6)`} value={form.password} onChange={upd("password")} data-testid="register-password" />
        {error && <div className="text-red-600 text-sm" data-testid="register-error">{error}</div>}
        <button disabled={loading} className="vt-btn-orange w-full" data-testid="register-submit">{loading ? "..." : t.auth.register}</button>
      </form>
      <p className="mt-6 text-sm text-neutral-500">
        {t.auth.hasAccount} <Link to="/login" className="link-underline text-black font-bold">{t.auth.login}</Link>
      </p>
    </div>
  );
}
